module.exports = __webpack_public_path__ + "img/pronunciation.a51ef403.svg";